module.exports = __webpack_public_path__ + "img/Sahabat Finansial Keluarga.6d1ee610.png";